import type en from "./en";

type WidenStrings<T> = T extends string
  ? string
  : T extends object
    ? { readonly [K in keyof T]: WidenStrings<T[K]> }
    : T;

const ku: WidenStrings<typeof en> = {
  common: {
    appName: "OELOX هاوبەش",
    save: "پاشەکەوت",
    cancel: "هەڵوەشاندنەوە",
    close: "داخستن",
    clear: "پاککردنەوە",
    retry: "دووبارە هەوڵبدە",
    loading: "بارکردن…",
    create: "دروستکردن",
    refresh: "نوێکردنەوە",
    search: "گەڕان",
    online: "ئۆنلاین",
    busy: "سەرقاڵ",
    offline: "ئۆفلاین",
    active: "چالاک",
    enabled: "چالاککراو",
    disabled: "ناچالاک",
    manual: "دەستی",
    pickup: "وەرگرتن",
    delivery: "گەیاندن",
    unassigned: "دیاری نەکراو",
    dash: "—",
    copy: "کۆپی کردن",
    copied: "کۆپی کرا.",
    copyFailed: "کۆپی نەکرا.",
  },
  language: {
    select: "زمان هەڵبژێرە",
    title: "زمان",
    hint: "عەرەبی یان کوردی یان ئینگلیزی بۆ فەزای کاری هاوبەش هەڵبژێرە.",
  },
  auth: {
    tag: "هاوبەش",
    loginTitle: "چوونەژوورەوەی هاوبەش",
    loginSubtitle:
      "بچۆ فەزای کاری هاوبەش. تەنها هەژماری هاوبەش — نە بزنس و نە بەڕێوەبەری OELOX.",
    email: "ئیمەیڵ",
    loginId: "ناوی بەکارهێنەر یان ئیمەیڵ",
    emailPlaceholder: "ناوی بەکارهێنەر یان you@partner.com",
    password: "وشەی نهێنی",
    passwordPlaceholder: "وشەی نهێنی",
    signIn: "چوونەژوورەوە",
    signingIn: "چوونەژوورەوە…",
    foot: "فەزای هاوبەشی پارێزراو · OELOX",
    hidePassword: "شاردنەوەی وشەی نهێنی",
    showPassword: "پیشاندانی وشەی نهێنی",
    authFailed: "سەلماندن سەرنەکەوت.",
    notPartner: "ئەم هەژمارە بە فەزای کاری هاوبەشەوە بەستراو نییە.",
    signInFailed: "نەتوانرا بچیتە ژوورەوە. دووبارە هەوڵ بدە.",
    invalidCredentials: "ناوی بەکارهێنەر یان وشەی نهێنی هەڵەیە.",
    emailNotConfirmed: "تکایە پێش چوونەژوورەوە ئیمەیڵەکەت پشتڕاست بکەوە.",
    tooMany: "هەوڵی زۆر. دوای کەمێک دووبارە هەوڵبدەوە.",
    networkError: "پەیوەندی سەرکەوتوو نەبوو. ئینتەرنێتەکەت بپشکنە و دووبارە هەوڵبدەوە.",
    signedIn: "چوویتە ژوورەوە.",
    changePasswordTitle: "وشەی نهێنی نوێ دابنێ",
    changePasswordSubtitle:
      "پێش کردنەوەی فەزای هاوبەش دەبێت وشەی نهێنی بگۆڕیت.",
    newPassword: "وشەی نهێنی نوێ",
    confirmPassword: "دووبارەکردنەوەی وشەی نهێنی",
    updatePassword: "نوێکردنەوەی وشەی نهێنی",
    updatingPassword: "نوێکردنەوە…",
    passwordTooShort: "وشەی نهێنی لانیکەم ٨ پیت بێت.",
    passwordMismatch: "وشەکانی نهێنی یەک ناگرنەوە.",
    passwordUpdateFailed: "نەتوانرا وشەی نهێنی نوێ بکرێتەوە. دووبارە هەوڵ بدە.",
    newPartnerLink: "هاوبەشی نوێ؟ بە کۆدی چالاککردن دەستپێبکە",
    passcodeTitle: "هاوبەشی نوێ",
    passcodeSubtitle: "کۆدی ٦ ژمارەیی لە بەڕێوەبەری OELOX بنووسە بۆ چالاککردنی هەژماری هاوبەش.",
    passcodeLabel: "کۆدی چوونەژوورەوە",
    passcodePlaceholder: "کۆدی ٦ ژمارەیی",
    continue: "بەردەوامبوون",
    checkingCode: "پشکنین…",
    back: "گەڕانەوە",
    backToSignIn: "گەڕانەوە بۆ چوونەژوورەوە",
    passcodeInvalid: "کۆد هەڵەیە. بپشکنە و دووبارە هەوڵ بدە.",
    passcodeUsed: "ئەم کۆدە پێشتر بەکارهاتووە.",
    passcodeExpired: "ماوەی ئەم کۆدە بەسەرچووە. کۆدێکی نوێ داوابکە.",
    passcodeAttempts: "هەوڵی زۆر. کۆدێکی نوێ داوابکە.",
    onboardingTitle: "تەواوکردنی دامەزراندن",
    onboardingSubtitle: "چوونەژوورەوەکەت دروست بکە بۆ چالاککردنی هەژماری هاوبەش.",
    displayName: "ناوی تۆ",
    username: "ناوی بەکارهێنەر",
    usernameHint: "٣–٣٠ پیت: a-z 0-9 . _ - — ئەمە ناسنامەی چوونەژوورەوەیەتە",
    usernameInvalid: "ناوی بەکارهێنەر نادروستە (٣–٣٠ پیت: a-z 0-9 . _ -).",
    usernameTaken: "ناوی بەکارهێنەر پێشتر بەکارهاتووە. یەکێکی تر تاقی بکەوە.",
    emailOptional: "ئیمەیڵ (ئارەزوومەندانە)",
    emailHint: "name@example.com",
    emailInvalid: "ئیمەیڵێکی دروست بنووسە یان بەتاڵی بهێڵەوە.",
    emailTaken: "ئیمەیڵ پێشتر تۆمارکراوە.",
    activateAccount: "چالاککردنی هەژمار",
    activatingAccount: "چالاککردن…",
    setupComplete: "هەژمار چالاک کرا. بچۆرە ژوورەوە بۆ بەردەوامبوون.",
    partnerActivated: "هەژمار چالاک کرا — بەخێربێیت بۆ OELOX Partner!",
    onboardingFailed: "دامەزراندن سەرکەوتوو نەبوو. دووبارە هەوڵ بدە.",
  },
  nav: {
    dashboard: "داشبۆرد",
    orders: "داواکارییەکان",
    drivers: "شۆفێرەکان",
    clients: "کڕیارەکان",
    analytics: "شیکارییەکان",
    wallet: "جزدان",
    settings: "ڕێکخستنەکان",
  },
  shell: {
    openMenu: "کردنەوەی مینیو",
    notifications: "ئاگادارییەکان",
    settings: "ڕێکخستنەکان",
    signOut: "چوونەدەرەوە",
    workspaceFallback: "هاوبەش",
  },
  overview: {
    eyebrow: "ناوەندی فەرمان",
    titleFallback: "هاوبەش",
    subtitle: "بزانە ئێستا چی ڕوودەدات — داواکاری، شۆفێر و کڕیار لە یەک تێڕوانین.",
    loadError: "نەتوانرا داواکاری ڕاستەوخۆ بار بکرێت. دانیشتن بپشکنە و دووبارە هەوڵ بدە.",
    updatedLive: "نوێکردنەوەی ڕاستەوخۆ",
    date: {
      ariaGroup: "مەودای بەروار",
      today: "ئەمڕۆ",
      custom: "تایبەت",
      showing: "پیشاندان",
      pickerEyebrow: "مەودای بەروار",
      pickerTitle: "ماوەی تایبەت",
      pickerSubtitle: "چالاکی داشبۆرد بەپێی بەروار فلتەر بکە.",
      presets: "ئامادەکراو",
      presetYesterday: "دوێنێ",
      presetLast7: "٧ ڕۆژی ڕابردوو",
      presetLast30: "٣٠ ڕۆژی ڕابردوو",
      presetThisMonth: "ئەم مانگە",
      from: "لە",
      to: "بۆ",
      confirm: "جێبەجێکردن",
    },
    flow: {
      title: "ڕێڕەوی داواکاری ڕاستەوخۆ",
      liveBadge: "ڕاستەوخۆ",
      hint: "کرتە لە قۆناغێک بکە بۆ فلتەرکردنی داواکارییەکان",
      activeNow: "ئێستا چالاک",
      ordersLabel: "داواکاری",
      aria: "ڕێڕەوی داواکاری ڕاستەوخۆ",
    },
    recentOrders: {
      title: "دوایین داواکارییەکان",
      subtitle: "دوایین داواکارییەکان — کرتە بکە بۆ کردنەوە لە داواکارییەکان.",
      empty: "هیچ داواکارییەک لەم بینینەدا نییە",
      filteredBy: "فلتەرکراو بە",
    },
    activeClients: {
      title: "کڕیارە چالاکەکان",
      subtitle: "دوایین چالاکی لەنێو کڕیارەکانت.",
      viewAll: "بینینی هەموو",
      empty: "هێشتا چالاکی نییە",
      ordersCount: "{count} داواکاری",
      openCount: "{count} کراوە",
      justNow: "ئێستا",
      noOrders: "هێشتا داواکاری نییە",
    },
    dispatch: {
      aria: "زانیاری ناردن",
      driverStatus: "دۆخی شۆفێرەکان",
      driverCaption: "ئۆنلاین {online} · سەرقاڵ {busy} · ئۆفلاین {offline}",
      activeLoad: "باری چالاک",
      loadCaption: "لە گەیاندندا {inDelivery} · دیاری نەکراو {unassigned}",
      fallback: "یەدەگی OELOX",
      fallbackCaption: "تەنها خوێندنەوە · ئەمڕۆ بەکارهاتوو —",
      wallet: "باڵانسی جزدان",
      walletCaption: "سنووری قەرز {limit}",
      walletLow: "باڵانس کەمە — پڕی بکەرەوە",
      walletBlocked: "لە ژێر سنوور — ناردن ڕاگیراوە",
    },
  },
  orders: {
    title: "داواکارییەکان",
    eyebrow: "ناوەندی کارەکان",
    subtitle:
      "داواکارییە هاتووەکان بەدواداچوون بکە، قبوڵیان بکە و بۆ شۆفێرەکان بنێرە — خۆکارانە نوێ دەکرێتەوە.",
    liveTitle: "داواکارییە ڕاستەوخۆکان",
    searchPlaceholder: "گەڕان بۆ کڕیار، میوان، تەلەفۆن…",
    searchAria: "گەڕان لە داواکارییەکان",
    emptyTitle: "هیچ داواکارییەک لەم قۆناغەدا نییە",
    emptyHint: "تەنها داواکاری کڕیارەکانی هاوبەش پیشان دەدرێن.",
    emptyListening: "داواکارییە نوێیەکان خۆکارانە لێرە دەردەکەون — ئەم شاشەیە کراوە بهێڵەوە.",
    emptyTitleStage: "ئێستا هیچ داواکارییەک لە قۆناغی «{stage}» نییە",
    emptyRangeHint: "بەدوای داواکاری کۆنتردا دەگەڕێیت؟ ماوەی کات لە سەرەوە بگۆڕە.",
    showAllOrders: "پیشاندانی هەموو داواکارییەکان",
    backToList: "گەڕانەوە بۆ داواکارییەکان",
    stagesAria: "قۆناغەکانی داواکاری",
    stages: {
      pending: "چاوەڕوان",
      processing: "ئامادەکردن",
      ready: "ئامادە",
      in_delivery: "گەیاندن",
      completed: "تەواو",
      cancelled: "هەڵوەشاوە",
      all: "هەموو",
    },
    stagesShort: {
      pending: "چاوەڕوان",
      processing: "ئامادەکردن",
      ready: "ئامادە",
      in_delivery: "گەیاندن",
      completed: "تەواو",
      cancelled: "هەڵوەشاوە",
      all: "هەموو",
    },
    method: {
      whatsappAi: "واتساپ AI",
      whatsapp: "واتساپ",
      manual: "دەستی",
      phone: "تەلەفۆن",
      webStore: "فرۆشگای وێب",
      pos: "خاڵی فرۆشتن",
      marketplace: "بازاڕ",
    },
    kpis: {
      processing: "لە پرۆسەدا",
      ready: "ئامادە",
      inDelivery: "لە گەیاندندا",
    },
    updatedNow: "ئێستا نوێکرایەوە",
    updatedAgo: "نوێکردنەوە {value}",
    showing: "پیشاندان {shown} لە {total}",
    sort: {
      label: "ڕیزکردنی داواکارییەکان",
      newest: "نوێترین سەرەتا",
      oldest: "کۆنترین سەرەتا",
      amount: "بەرزترین بڕ",
    },
    waitNow: "ئێستا",
    accept: "قبوڵکردنی داواکاری",
    acceptShort: "قبوڵکردن",
    decline: "ڕەتکردنەوەی داواکاری",
    declineConfirm:
      "ئەم داواکارییە ڕەت بکرێتەوە؟ لە لیستەکەت دەردەچێت و بەفرۆشگاکە ئاگادار دەکرێتەوە.",
    declineReasonPrompt: "هۆکار (ئارەزوومەندانە)",
    declineModal: {
      title: "ڕەتکردنەوەی داواکاری",
      subtitle: "داواکارییەکە لە لیستەکەت دەردەچێت و بەفرۆشگاکە ئاگادار دەکرێتەوە.",
      reasonLabel: "هۆکار",
      reasons: {
        busy: "ئێستا زۆر سەرقاڵم",
        far: "زۆر دوور / دەرەوەی ناوچە",
        closed: "داخراو یان بەردەست نییە",
        other: "هیتر",
      },
      noteLabel: "تێبینی (ئارەزوومەندانە)",
      notePlaceholder: "تێبینییەکی کورت بۆ فرۆشگا…",
      confirm: "ڕەتکردنەوەی داواکاری",
    },
    assign: "دیاریکردنی شۆفێر",
    assignShort: "دیاریکردن",
    changeShort: "گۆڕین",
    needsDriver: "پێویستی بە شۆفێرە",
    detailEmpty: "داواکارییەک هەڵبژێرە",
    detailEmptyHint: "کلیک لە هەر داواکارییەک لە لیستەکە بکە بۆ بینینی وردەکارییەکانی لێرە.",
    items: "بڕگەکان",
    notes: "تێبینییەکان",
    detail: {
      customer: "کڕیار",
      timeline: "کاتنامە",
      created: "دروستکرا",
      accepted: "قبوڵ کرا",
      copyNumber: "کۆپی ژمارەی داواکاری",
      returnToStore: "ڕەتکراوە · گەڕاندنەوە بۆ دوکان",
      copyPhone: "کۆپی ژمارەی تەلەفۆن",
      call: "پەیوەندی بە کڕیار",
      openMap: "کردنەوە لە نەخشە",
      copyAddress: "کۆپی ناونیشان",
      more: "زیاتر",
      changeDriver: "گۆڕینی شۆفێر",
      noDriverAssigned: "هێشتا شۆفێر دیاری نەکراوە.",
      next: {
        pending: "هەنگاوی داهاتوو: داواکارییەکە قبوڵ بکە، پاشان شۆفێری گەیاندن هەڵبژێرە.",
        driver: "هەنگاوی داهاتوو: شۆفێرێک دیاری بکە بۆ گەیاندنی ئەم داواکارییە.",
        onTheWay: "داواکارییەکە لای شۆفێرە — چاودێری گەیاندنەکە بکە.",
      },
      itemsCount: "{count} بڕگە",
      km: "{value} کم",
      distance: "مەسافە",
      payment: "پارەدان",
      paymentType: {
        prepaid: "پێشوەخت پارەدراو",
        cod: "پارەدان لە کاتی گەیاندن",
        payAtCashier: "پارەدان لە کاشێر",
        unknown: "پارەدان نەزانراو",
      },
      method: "شێواز",
      methodCash: "کاش",
      methodCard: "کارت",
      methodWallet: "جزدان",
      methodCod: "پارەدان لە گەیاندن",
      statusLabel: "دۆخ",
      statusPaid: "پارەدراو",
      statusUnpaid: "نەپارەدراو",
      statusCodCollected: "پارە کۆکراوەتەوە",
      statusPickupCollected: "لە کاتی وەرگرتن دراوە",
      statusFailed: "پارەدان سەرکەوتوو نەبوو",
      statusRefunded: "گەڕێنراوەتەوە",
      cashCollector: "کۆکەرەوەی کاش",
      driverCollects: "شۆفێر کاش کۆدەکاتەوە",
      deliveryFee: "کرێی گەیاندن",
      feePayerCustomer: "کڕیار دەدات",
      feePayerRestaurant: "چێشتخانە دەدات",
      feePayerOelox: "OELOX دەدات",
      feePayerPartner: "هاوبەش دەدات",
      feePayerFree: "گەیاندنی خۆڕایی",
      clientCharge: "کرێی هاوبەش",
      partnerFeePerOrder: "بۆ هەر داواکاری",
      partnerFeePercentage: "ڕێژە",
      prep: "ئامادەکردن",
      prepMinutes: "~{minutes} خولەک",
      placed: "دروستکرا لە",
      pickupReady: "ئامادە بۆ وەرگرتن",
      total: "کۆی گشتی",
    },
    assignSection: "دیاریکردنی شۆفێر",
    requestOelox: "داواکاری شۆفێری OELOX",
    reassign: "دووبارە دیاریکردن",
    clearDriver: "لابردنی شۆفێر",
    noDrivers: "هێشتا شۆفێر نییە. شۆفێر زیاد بکە یان یەدەگی OELOX داوا بکە.",
    acceptModal: {
      title: "قبوڵکردنی داواکاری",
      dispatchTitle: "ناردن · {business}",
      partnerDrivers: "شۆفێرەکانی هاوبەش",
      steps: "1) داواکارییەکە قبوڵ بکە · 2) لە خوارەوە شۆفێرێک هەڵبژێرە — یان بۆ هەمووان بنێرە.",
      selectDriversHint:
        "یەک شۆفێر هەڵبژێرە بۆ دیاریکردن، یان چەند دانە بۆ بڵاوکردنەوە.",
      sendToAll: "ناردن بۆ هەموو شۆفێرە ئامادە و سەرقاڵەکان",
      sendToAllHint: "هەر شۆفێری هاوبەشی شایستە دەتوانێت ئەم گەیاندنە قبوڵ بکات.",
      selectOeloxGlobal: "هەڵبژاردنی شۆفێرە جیهانییەکانی OELOX",
      oeloxNoDrivers: "ئێستا هیچ شۆفێری جیهانی OELOX ئۆنلاین نییە.",
      requestAnyOelox: "ڕێگە بدە OELOX شۆفێرێک هەڵبژێرێت",
      oeloxOnline: "ئۆنلاین",
      oeloxOffline: "ئۆفلاین",
      assignDriver: "دیاریکردنی شۆفێر",
      blastSelected: "بڵاوکردنەوە بۆ شۆفێرە هەڵبژێردراوەکان",
      dispatch: "ناردن",
      acceptOnly: "تەنها قبوڵکردن",
      acceptAndAssign: "قبوڵکردن و دیاریکردنی شۆفێر",
      searchDrivers: "گەڕان بۆ شۆفێر…",
      noDriverMatch: "هیچ شۆفێرێک لەگەڵ گەڕانەکەت ناگونجێت.",
      selectedCount: "{count} هەڵبژێردراو",
      bypassModeHint:
        "دۆخی تێپەڕین لە قبوڵکردندا خۆکار بڵاو دەکاتەوە. بۆ هەڵبژاردنی شۆفێر بڕۆ بۆ ناردنی دەستی.",
      noPartnerDrivers: "هیچ شۆفێری هاوبەش لە هێڵەکەتدا نییە.",
      noAssignableDrivers: "ئێستا هیچ شۆفێری هاوبەشی ئۆنلاین یان سەرقاڵ نییە.",
    },
    toast: {
      accepted: "داواکاری قبوڵ کرا.",
      acceptedNoDrivers: "قبوڵ کرا — هیچ شۆفێری هاوبەش بەردەست نییە.",
      acceptedBlast: "قبوڵ کرا و بۆ شۆفێرەکانت بڵاوکرایەوە.",
      acceptedDispatched: "قبوڵ کرا و شۆفێر ئاگادار کرا.",
      dispatched: "شۆفێرەکان ئاگادار کران.",
      assigned: "شۆفێر دیاری کرا.",
      reassigned: "شۆفێر دووبارە دیاری کرا.",
      cleared: "شۆفێر لابرا.",
      oeloxRequested: "شۆفێری OELOX داوا کرا.",
      oeloxAssigned: "شۆفێری OELOX دیاری کرا.",
      declined: "داواکاری ڕەتکرایەوە.",
      newOrder: "داواکارییەکی نوێ وەرگیرا",
      view: "بینین",
    },
  },
  drivers: {
    title: "شۆفێرەکان",
    searchPlaceholder: "گەڕان بۆ شۆفێر…",
    searchAria: "گەڕان بۆ شۆفێرەکان",
    add: "زیادکردنی شۆفێر",
    refresh: "نوێکردنەوە",
    emptyTitle: "هێشتا شۆفێر نییە",
    emptyHint: "شۆفێری فلیتی هاوبەش دروست بکە بۆ گەیاندن.",
    createTitle: "زیادکردنی شۆفێر",
    name: "ناو",
    namePlaceholder: "ناوی شۆفێر",
    phone: "تەلەفۆن",
    vehicleType: "جۆری ئۆتۆمبێل",
    vehicleNumber: "ژمارەی ئۆتۆمبێل",
    bicycle: "پاسکیل",
    motorcycle: "مۆتۆر",
    car: "ئۆتۆمبێل",
    creating: "دروستکردن…",
    create: "دروستکردن",
    modePasscode: "زیادکردن بە کۆدی نهێنی",
    modeReady: "ئامادە بۆ بەکارهێنان",
    passcodeHint:
      "شۆفێرێکی فلیتی هاوبەش بە کۆدێکی یەکجارە دروست دەکات بۆ چالاککردن لە ئەپی شۆفێر.",
    readyHint:
      "هەژماری شۆفێرەکە ئێستا دروست دەکات بە زانیاری چوونەژوورەوەی خوارەوە. یەکجار بیڕەوانە بکە.",
    address: "ناونیشان",
    username: "ناوی بەکارهێنەر",
    usernameHint: "٣–٣٠ پیت: a-z، 0-9، خاڵ، داش، ژێرهێڵ.",
    createReady: "دروستکردنی هەژمار",
    readyCredentialsHint:
      "شۆفێرەکە ئێستا دەتوانێت بەم زانیارییانە بچێتە ئەپی شۆفێر.",
    resetPassword: "دووبارە دانانی وشەی نهێنی",
    deactivate: "ناچالاککردن",
    passcode: "کۆدی نهێنی",
    modeLabel: "جۆری گرێبەست",
    mode: {
      own: "کارمەند",
      paid: "بەپەیمان",
    },
    modeOwnHint: "کارمەند — لەسەر مووچەی خۆت و ئۆتۆمبێل لەسەر خۆت؛ کرێی گەشت نییە.",
    modePaidHint: "بەپەیمانی سەربەخۆ — ئۆتۆمبێلی خۆی، و بۆ هەر گەشت لە جزدانی خۆیەوە پارە وەردەگرێت.",
    modeToastChanged: "جۆری گرێبەست نوێکرایەوە.",
    tripPayTitle: "کرێی گەشت",
    tripPayLabel: "کرێی شۆفێر بۆ هەر گەشت (IQD)",
    tripPayPlaceholder: "بۆ نموونە 2000",
    tripPayUsesDefault: "بنەڕەتی هاوبەش: {amount} — بەتاڵی بهێڵەوە بۆ بەکارهێنانی.",
    tripPayHint: "بەتاڵی بهێڵەوە بۆ بەکارهێنانی کرێی بنەڕەتی هاوبەش.",
    tripPaySaved: "کرێی شۆفێر نوێکرایەوە.",
    toast: {
      created: "شۆفێر دروست کرا.",
      deactivated: "شۆفێر ناچالاک کرا.",
      activated: "شۆفێر چالاک کرا.",
      updated: "زانیاری شۆفێر نوێکرایەوە.",
    },
    presence: {
      online: "ئۆنلاین",
      busy: "سەرقاڵ",
      offline: "ئۆفلاین",
    },
    subtitle: "فلیتی هاوبەش — ئامادەیی ڕاستەوخۆ، کرێ و جزدانەکان.",
    columns: {
      name: "شۆفێر",
      status: "دۆخ",
      vehicle: "ئۆتۆمبێل",
      activeOrders: "داواکاری چالاک",
      mode: "دۆخ",
      pay: "کرێی گەشت",
      wallet: "جزدان",
    },
    filterAll: "هەموو دۆخەکان",
    payDefaultMark: "بنەڕەت",
    back: "گەڕانەوە بۆ شۆفێرەکان",
    notFound: "شۆفێر نەدۆزرایەوە",
    tabs: {
      settings: "ڕێکخستنی شۆفێر",
      reports: "ڕاپۆرتەکان",
      operations: "کارەکان",
      overview: "پێداچوونەوە",
      wallet: "جزدان",
      payouts: "پارەدانەکان",
      mode: "دۆخ",
    },
    tabsAria: "بەشەکانی شۆفێر",
    deactivateTitle: "شۆفێر ناچالاک بکرێت؟",
    deactivateBody: "وەرگرتنی داواکاری ڕادەگرێت و لە لیستەکانی ناردن لادەبرێت.",
    inactive: "ناچالاک",
    activate: "چالاککردن",
    whatsapp: "واتساپ",
    editNotAvailable: "تەنها خوێندنەوە — دەستکاریکردن پشتگیری سێرڤەر دەوێت.",
    missingFields:
      "هێشتا لە سێرڤەر نییە: ناونیشانی شۆفێر، ناسنامەی نیشتمانی و بەڵگەنامەی زیادە.",
    vehicleModel: "مۆدێلی ئۆتۆمبێل",
    vehicleColor: "ڕەنگ",
    vehicleYear: "ساڵ",
    documents: "بەڵگەنامەکان",
    licenseImage: "وێنەی مۆڵەتی لێخوڕین",
    selfPhoto: "وێنەی شەخسی",
    open: "کردنەوە",
    invalidYear: "ساڵێکی دروست بنووسە (1980–2100).",
    assignExisting: {
      cta: "شۆفێری خاوەن حساب زیاد بکە",
      title: "زیادکردنی شۆفێرێک کە پێشتر حسابی هەیە",
      subtitle:
        "بە ژمارەی تەلەفۆن بگەڕێ. ئەگەر پێشتر لای کڕیارەکان کار بکات، دوای دڵنیاکردنەوە لادەبرێت — گەشتی چالاک رێگرە.",
      search: "گەڕان",
      notFound: "هیچ شۆفێرێک بەم ژمارەیە نییە.",
      ownedByYou: "ئەم شۆفێرە پێشتر لە فلیتەکەتدایە.",
      ownedOther: "ئەم شۆفێرە پێشتر هی هاوبەشێکی ترە.",
      sharedDriver: "شۆفێری هاوبەش",
      clientsLabel: "ئێستا بەستراوە بە:",
      unlinkNote: "بە دڵنیاکردنەوە لەم کڕیارانە لادەبرێت و زیاددەکرێت بۆ فلیتەکەت.",
      move: "زیادکردنی بۆ فلیتەکەم",
      moveWithUnlink: "لابردن و زیادکردنی بۆ فلیتەکەم",
      moved: "شۆفێر زیادکرا بۆ فلیتەکەت.",
      movedWithClients: "شۆفێر زیادکرا بۆ فلیتەکەت — لابراوە لە: {clients}",
      alreadyYours: "شۆفێر پێشتر لە فلیتەکەتدایە.",
    },
    release: {
      title: "دەرکردن لە فلیت",
      hint: "ئەم شۆفێرە لە فلیتەکەت دەردەکەیت. دەبێتە بێ‌خاوەن و دواتر بە پاسکۆد یان هاوبەشێکی تر دەگەڕێتەوە.",
      cta: "دەرکردن",
      toast: "شۆفێر لە فلیتەکەت دەرکرا.",
    },
    reports: {
      orderNo: "داواکاری",
      client: "کڕیار",
      ordersHistory: "مێژووی داواکارییەکان",
      noOrders: "هێشتا داواکاری بۆ ئەم شۆفێرە نییە",
      currentOrders: "داواکاری ئێستا",
      tripHistory: "مێژووی گەشتەکان",
      noTrips: "هێشتا گەشتی تەواوکراو نییە",
      noCurrentOrders: "هیچ داواکاری چالاک دیاری نەکراوە",
      limitNote: "دوایین ٢٥ گەشت",
    },
  },
  clients: {
    title: "کڕیارەکان",
    searchPlaceholder: "گەڕان بۆ بزنس…",
    searchAria: "گەڕان بۆ کڕیارەکان",
    add: "زیادکردنی کڕیار",
    refresh: "نوێکردنەوە",
    emptyTitle: "هێشتا کڕیاری هاوبەش نییە",
    emptyHint: "بزنسە بەستراوەکان یان دروستکراوەکان لێرە دەردەکەون.",
    createTitle: "زیادکردنی کڕیار",
    businessName: "ناوی بزنس",
    phone: "تەلەفۆن",
    address: "ناونیشان",
    addressPlaceholder: "شەقام، شار…",
    emailOptional: "ئیمەیڵ (ئارەزوومەندانە — بۆ پسووڵەکان)",
    username: "ناوی بەکارهێنەر (ناسنامەی چوونەژوورەوەی کڕیار)",
    usernameHint:
      "٣–٣٠ پیت: a-z، 0-9، تەنها داش. کڕیار بەمە دەچێتە ژوورەوە — نەک ئیمەیڵ.",
    edit: "دەستکاری کڕیار",
    editTitle: "دەستکاری کڕیار",
    editHint: "ناوی بەکارهێنەر ناسنامەی چوونەژوورەوەیە. ئیمەیڵ ئارەزوومەندانەیە — بۆ پسووڵەکان.",
    delete: "سڕینەوە",
    deleteTitle: "کڕیار بسڕدرێتەوە؟",
    deleteBody:
      "سڕینەوەی نەرم: دۆخ دەبێت بە «هەڵوەشێنراو» و کۆدەکانی چالاککردن ناچالاک دەکرێن. ئەرشیف دەمێنێتەوە.",
    deleteConfirmCta: "بەڵێ، «{name}» بسڕدرێتەوە",
    save: "پاشەکەوتکردن",
    creating: "دروستکردن…",
    create: "دروستکردن + کۆد",
    modePasscode: "زیادکردن بە کۆدی نهێنی",
    modeReady: "ئامادە بۆ بەکارهێنان",
    readyHint:
      "هەژماری فرۆشگاکە ئێستا دروست دەکات بە زانیاری چوونەژوورەوەی خوارەوە. یەکجار بیڕەوانە بکە — خاوەنەکە دەتوانێت دواتر وشەی نهێنی بگۆڕێت.",
    slug: "لینکی گشتی فرۆشگا",
    slugHint: "لینکی گشتی: /store/<slug>",
    createReady: "دروستکردنی هەژمار",
    readyCredentialsHint:
      "فرۆشگاکە ئێستا دەتوانێت بچێتە ژوورەوە. فرۆشگای گشتی شاراوە دەمێنێتەوە تا خاوەنەکە لە ڕێکخستنەکان چالاکی بکات.",
    passcodeTitle: "کۆدی چالاککردنی بزنس",
    passcodeHint:
      "یەکجار هاوبەشی بکە بۆ چالاککردن. ناسنامە وەک هاوبەش + controlling_partner_id دادەنرێت.",
    dismiss: "لابردن",
    reissue: "کۆد",
    passcodeModalHint:
      "یەک جار بەکارهێنان — دوای نزیکەی ٢ کاتژمێر بەسەردەچێت. بۆ چالاککردنی هەژمارەکە بیڕەوانە بکە بۆ فرۆشگاکە.",
    openOrders: "داواکاری کراوەکان",
    active: "چالاک",
    inactive: "ناچالاک",
    unknownStatus: "نەزانراو",
    openOrdersKpi: "داواکاری کراوەکان",
    noActivity: "هێشتا چالاکی نییە",
    driverPrefix: "شۆفێر: {name}",
    toast: {
      created: "کڕیار وەک کڕیاری هاوبەش دروست کرا.",
      updated: "کڕیار نوێکرایەوە.",
      deleted: "کڕیار سڕایەوە — دۆخ هەڵوەشێنراو.",
    },
    eyebrow: "تۆماری کڕیارەکان",
    subtitle: "ئەو بزنسەکانی کە هاوبەش بەڕێوەیانی دەبات — داواکاری، کرێی گەیاندن و ئەوەی لەسەریانە.",
    totalKpi: "کڕیارەکان",
    trial: "تاقیکاری",
    onboarding: "لە چالاککردندا",
    filterAll: "هەموو",
    filtersAria: "پاڵاوتن بەپێی دۆخی کڕیار",
    colClient: "کڕیار",
    colStatus: "دۆخ",
    colOrders: "داواکاری",
    colCompleted: "تەواوکراو",
    colFees: "کرێی گەیاندن",
    colCharges: "کرێی خزمەتگوزاری",
    colOutstanding: "ماوە",
    colLastOrder: "دوایین داواکاری",
    colOpen: "کراوە",
    view: "بینین",
    note: "داواکاری و کرێیەکان کۆی گشتی کۆکراوەن؛ ماوە باڵانسی نەتەسفیەکراو پیشان دەدات.",
  },
  clientView: {
    back: "گەڕانەوە بۆ کڕیارەکان",
    notFound: "کڕیار نەدۆزرایەوە.",
    tabsAria: "بەشەکانی ڕاپۆرتی کڕیار",
    tabs: {
      overview: "پێداچوونەوەی گشتی",
      orders: "داواکارییەکان",
      statement: "کرێ و کەشف حساب",
      drivers: "شۆفێرەکان",
    },
    ordersRange: "داواکاری (ماوە)",
    activeNow: "ئێستا چالاک",
    deliveryIncome: "داهاتی گەیاندن",
    clientCharges: "کرێی خزمەتگوزاری",
    outstanding: "ماوە",
    driversNow: "شۆفێری چالاک",
    businessInfo: "زانیاری بزنس",
    login: "ناسنامەی چوونەژوورەوە",
    ownerEmail: "ئیمەیڵی خاوەن",
    linkedAt: "بەستراویەتی",
    dispatchAuthority: "دەسەڵاتی ناردن",
    currency: "دراو",
    terms: "مەرجە بازرگانییەکان",
    termsHint: "مەرجە بازرگانییەکان لەلایەن تیمی بەڕێوەبەرایەتی OELOX دیاری دەکرێن.",
    noOrdersRange: "هیچ داواکارییەک نییە لەم ماوەیەدا.",
    legacyNote: "{count} گەیاندنی تەواوکراو کرێی گەیاندنی نرخکراوی نییە (داتای کۆن).",
  },
  clientOrders: {
    searchPlaceholder: "گەڕان لە داواکارییەکان…",
    searchAria: "گەڕان لە داواکارییەکانی کڕیار",
    stageFilter: "قۆناغی داواکاری",
    fulfillmentFilter: "جۆری داواکاری",
    export: "هەناردەکردن CSV",
    colDate: "بەروار",
    colOrder: "داواکاری",
    colCustomer: "کڕیار",
    colDriver: "شۆفێر",
    colStatus: "دۆخ",
    colTotal: "کۆی گشتی",
    colDeliveryFee: "کرێی گەیاندن",
    colResponsibility: "دەرماڵەی کرێ",
    colCharge: "کرێ",
    colPayment: "پارەدان",
    colKm: "کم",
    showing: "پیشاندانی {from}–{to} لە {total}",
    prev: "پێشوو",
    next: "داهاتوو",
  },
  statement: {
    charged: "وەرگیراو",
    settled: "تەسفیەکراو",
    pendingInRange: "هەڵواسراو (ماوە)",
    outstanding: "ماوە",
    cancelledFees: "{count} داواکاری هەڵوەشێنراو لەگەڵ کرێ",
    feeMix: "دابەشکردنی دەرماڵەی کرێی گەیاندن",
    summary: "کورتەی",
    instantTotal: "کۆی کرێی خێرا",
    voidedTotal: "هەڵوەشێنراو لەم ماوەیەدا",
    wallet: "جزدان",
    walletBalance: "باڵانسی جزدان",
    walletPending: "قەرزی هەڵواسراو",
    serviceFeeNote: "کرێی خزمەتگوزاری بۆ هەر داواکاری تۆمار دەکرێت؛ بڕگە قەرزییەکان تەسفیە بکە بۆ پاککردنەوەی هەڵواسراوەکان.",
    ledger: "تۆمارەکانی لیستەر",
    empty: "هیچ کرێیەک نییە لەم ماوەیەدا.",
    emptyLedger: "هێشتا هیچ کرێیەک تۆمار نەکراوە.",
    recentLedger: "دوایین کرێیەکان",
    settle: "تەسفیە",
    settleToast: "بڕگە تەسفیە کرا.",
    settleFailed: "نەتوانرا بڕگە تەسفیە بکرێت.",
    colDate: "بەروار",
    colOrder: "داواکاری",
    colType: "جۆر",
    colOrderTotal: "کۆی داواکاری",
    colFee: "کرێ",
    colMode: "شێواز",
    colStatus: "دۆخ",
    colPayer: "دەرماڵەدەر",
    colOrders: "داواکاری",
    colFees: "کرێیەکان",
  },
  wallet: {
    title: "جزدانی شۆفێر",
    owesDriver: "هاوبەش قەرزاری شۆفێرە",
    driverOwes: "شۆفێر قەرزاری هاوبەشە",
    settled: "تەسفیە کراوە — قەرز نییە",
    empty: "هێشتا تۆمار لە جزداندا نییە.",
    amountPlaceholder: "بڕ (+ یان −)",
    notePlaceholder: "تێبینی (ئارەزوومەندانە)",
    addEntry: "زیادکردنی تۆمار",
    entryHint:
      "+ واتە قەرزاری شۆفێریت · − واتە شۆفێر قەرزاری تۆیە (وەک نەقدی وەرگیراو).",
    toastEntryAdded: "تۆماری جزدان زیاد کرا.",
    type: {
      trip_fee: "کرێی گەیاندن",
      cod_collected: "نەقد لە کڕیار وەرگیرا",
      adjustment: "تۆماری دەستی",
      topup: "پڕکردنەوەی جزدان",
      trip_charge: "کەمکردنەوەی گەشت",
    },
  },
  clientWallet: {
    title: "جزدانی کڕیار",
    balance: "باڵانس",
    limit: "سنووری نەرێنی",
    empty: "هێشتا جووڵە لە جزداندا نییە.",
    topupPlaceholder: "بڕی پڕکردنەوە",
    topup: "پڕکردنەوە",
    limitPlaceholder: "سنوور (سفر یان نەرێنی)",
    setLimit: "پاشەکەوتکردنی سنوور",
    hint: "کرێی گەیاندن بۆ هەر گەشتێکی تەواوبوو کەم دەکرێت؛ پڕکردنەوە باڵانس دەگەڕێنێتەوە. سنووری نەرێنی پارێزەرێکی دەستییە — هێشتا جێبەجێ نەکراوە.",
    toastTopup: "جزدان پڕکرایەوە.",
    toastLimit: "سنوور پاشەکەوت کرا.",
    limitInvalid: "سنوور دەبێت سفر یان ژمارەیەکی نەرێنی بێت.",
    failed: "نوێکردنەوەی جزدان سەرنەکەوت.",
  },
  clientLedger: {
    title: "کرێی گەیاندن کە دەبێت بدرێت بە هاوبەش",
    balanceToPay: "بری شایستەی دان",
    feesTotal: "کۆی کرێەکان",
    paidTotal: "دراوە",
    empty: "ئێستا هیچ شایستەیەک نییە.",
    returnToStore: "گەڕاندنەوە بۆ دوکان",
    note: "ئەو کرێی گەیاندنەی دوکان هەڵیدەگرێت (گەیاندنی خۆڕایی بۆ کڕیار) و بە کاش نەدراوە بە شۆفێر — لەگەڵ هاوبەش ڕێک دەخرێت.",
    payTitle: "تۆمارکردنی پارەدان لە دوکانەوە",
    payHint: "ئەو بڕە تۆمار بکە کە لە دوکانەوە وەرتگرتووە — ڕاستەوخۆ لە شایستە کەم دەکات.",
    payAmount: "بڕ",
    payNote: "تێبینی (ئیختیاری)",
    payCurrent: "ئێستا شایستە: {amount}",
    payAfter: "دوای پارەدان: {amount}",
    paySubmit: "تۆمارکردنی پارەدان",
    payToast: "پارەدانی {amount} تۆمارکرا.",
    paymentsTitle: "پارەدانە تۆمارکراوەکان",
    owesPartner: "کڕیار بەرماڵە بە هاوبەش",
    partnerOwes: "هاوبەش بەرماڵە بە کڕیار",
    net: "کۆی گشتی",
  },
  walletV2: {
    title: "جزدانی هاوبەش",
    hint: "جزدانی فاکتۆرکردنی کۆکراوە — تەنها کرێی پلاتفۆرم و تسویەی کرێی گەیاندن.",
    blockedBanner:
      "ناردن راگیراوە: جزدان لە ژێر سنووری کرێدیتە. داوا لە OELOX بکە باڵانس پڕبکاتەوە بۆ بەردەوامبوونی ناردن — کارەکانی فرۆشگا تووشی هیچ نابێت.",
    lowBanner:
      "باڵانسی جزدان لە سنووری ئاگادارکەرەوە یە یان کەمترە — بە زوویی پڕی بکەرەوە بۆ ئەوەی ناردن نەوەستێت.",
    balanceLabel: "باڵانس",
    statusHealthy: "ساغ",
    statusLow: "باڵانسی کەم",
    statusBlocked: "بلۆک کراوە",
    updatedAt: "نوێکراوەتەوە {time}",
    creditLimit: "سنووری کرێدیت",
    creditLimitHint: "ناردن لە خوار ئەم باڵانسە دەوەستێت.",
    alertThreshold: "سنووری ئاگادارکەرەوە",
    alertThresholdHint: "ئاستی ئاگادارکەرەوەی باڵانسی کەم.",
    feeOnlyNote:
      "جزدان تەنها کرێی پلاتفۆرمی ٢٥٠ د.ع بۆ هەر داواکارییەکی تەواوکراو و تسویەی کرێی گەیاندن دەگرێتەوە — نرخی خواردن/داواکاری هەرگیز ناچێتە جزدانەوە.",
    totalsLine: "بەکارهێنانی پلاتفۆرم {fees} · کۆی پڕکردنەوە {topups} · {count} تۆمار",
    transactionsTitle: "جوڵەکان",
    empty: "هێشتا هیچ جوڵەیەک نییە.",
    colDate: "بەروار",
    colType: "جۆر",
    colDescription: "وەسف",
    colAmount: "بڕ",
    colBalanceAfter: "باڵانس دوای",
    fleetTitle: "جزدانەکانی شۆفێرانی کاروان",
    fleetTotals: "بۆ ڕادەستکردن: {cash} · شایستەی دان: {due}",
    fleetEmpty: "هێشتا شۆفێری کاروان نییە.",
    fleetNote:
      "جزدانی شۆفێر: + واتە شۆفێر پارەی لایە؛ − واتە شایستەی دان هەیە. لە پانێڵی شۆفێرەوە چارەسەری بکە.",
    colDriver: "شۆفێر",
    colBalance: "باڵانس",
    colCashHeld: "پارەی لایە",
    colPayoutDue: "شایستەی دان",
    txType: {
      topup: "پڕکردنەوە",
      platform_fee: "کرێی پلاتفۆرم",
      adjustment: "ڕێکخستن",
      refund: "گەڕاندنەوە",
      cash_collected: "پارەی کۆکراوە",
      trip_earnings: "قازانجی گەشت",
      cash_handover: "ڕادەستکردنی پارە",
      partner_margin: "پشکی هاوبەش",
      payout: "دان",
      order_value_collected: "وەرگرتنی نرخی داواکاری",
      rejection_refund: "گەڕاندنەوەی داواکاری ڕەتکراوە",
      rejection_fee_keep: "کرێی شۆفێر (داواکاری ڕەتکراوە)",
      other: "تۆمار",
    },
    txDesc: {
      cashCollected: "پارەی کۆکراوە لە دەرگا",
      orderValueCollected: "نرخی داواکاری وەرگیرا لە دەرگا",
      tripEarnings: "قازانجی گەیاندن",
      partnerShareAuto: "پشکی هاوبەش لە گەیاندن (کۆکردنەوەی خۆکار)",
      marginDeducted: "پشکی هاوبەش لە گەشت — لە باڵانسی پێشەوە کەم دەکرێتەوە",
      feeReceived: "کرێی گەیاندنەکە وەرگیرا",
      platformFee: "کرێی بەکارهێنانی پلاتفۆرم",
      cashHandedOver: "ڕادەستکردنی پارە بە هاوبەش",
      payoutToDriver: "دان بە شۆفێر",
      topup: "پڕکردنەوەی جزدان",
      rejectionRefund: "داواکاری ڕەتکراوە — گەڕاندنەوەی نرخی پارەدراو لە کاشێر",
      rejectionFeeKeep: "داواکاری ڕەتکراوە — کرێی شۆفێر بەپێی بڕیاری هاوبەش",
    },
    driverOwes: "شۆفێر پارەی لایە بۆ ڕادەستکردن",
    payoutDue: "شایستەی دان بۆ شۆفێر",
    settled: "تەواوکرا — هیچ شایستەیەک نییە",
    cashOnHand: "پارەی لایە",
    settlementsTitle: "تسویەی گەشتەکانی نوێ",
    colTripDate: "بەروار",
    colTripFee: "کرێی گەیاندن",
    colTripEarnings: "قازانج",
    colTripCash: "پارە",
    colTripStatus: "داواکاری",
    settleTitle: "جوڵەی کاش لەگەڵ شۆفێر",
    settleHandover: "ڕادەستکردنی پارە",
    settlePayout: "دان",
    settleAmount: "بڕ",
    settleNote: "هۆکار (ئیختیاری)",
    settleSubmit: "تۆمارکردن",
    settleTopup: "زیادکردنی باڵانس",
    settleHint:
      "ڕادەستکردن: شۆفێر پارەی کۆکراوە دەگەڕێنێتەوە (سنوور: ئەو پارەیەی لایە). دان: شایستە بدە (سنوور: شایستەی دان).",
    topupHint:
      "زیادکردنی باڵانس بۆ جزدانی شۆفێر — وەک ڕێکخستن لەسەر باڵانسی ساف تۆمار دەکرێت (بۆ پێشەکی/کاش).",
    toastSettled: "تسویە تۆمارکرا.",
    toastToppedUp: "باڵانس زیادکرا بۆ جزدانی شۆفێر.",
    stDriverOwes: "شۆفێر بەرماڵە بە هاوبەش",
    stPartnerOwes: "هاوبەش بەرماڵە بە شۆفێر",
    stNet: "باڵانسی ساف",
    stWalletBalance: "باڵانسی جزدان",
    stTripsCaption: "گەشتە تەواوکراوەکان",
    stIncomeCaption: "بەشی خۆی لە هەر گەشتێک",
    stBalanceCaption: "باڵانسی پڕکردنەوە — پشکی هاوبەش لە هەر گەشتێک کەم دەکرێتەوە",
    stBalanceNegative: "باڵانسی سالب — باڵانس زیاد بکە بۆ چارەسەرکردنی",
    addBalanceTitle: "زیادکردنی باڵانس",
    addBalanceHint:
      "بڕەکە زیاد دەکرێت بۆ باڵانسی پێشەوەی شۆفێر — پشکی هاوبەش خۆکارانە لە هەر گەشتێک کەم دەکرێتەوە.",
    addBalanceSubmit: "زیادکردنی باڵانس",
    addBalanceCurrent: "ئێستا: {amount}",
    addBalanceAfter: "دوای زیادکردن: {amount}",
    addBalanceNegative:
      "وەک سالب دەردەکەوێت (شایەنی چارەسەر) تا باڵانس زیاد بکرێت.",
    moveTake: "وەرگرتن لە شۆفێر",
    moveGive: "دان بە شۆفێر",
    moveTakeHint: "کاش لە شۆفێر وەردەگریت (ئێستا {amount} لایە).",
    moveTakeDue: "بۆ وەرگرتن: {amount}",
    moveGiveDue: "بۆ دان: {amount}",
    takeScopeLabel: "چی لێوەردەگریت؟",
    scopeNetDesc: "هەموو ئەو کاشەی کە بەرماڵەیە",
    scopeDeliveryDesc: "جیاوازی کرێی گەیاندنی کۆکراوە",
    scopeOrderDesc: "نرخی داواکارییە کۆکراوەکان بە کاش",
    givePayoutDesc: "شایستەی ماوە بدە بە شۆفێر",
    moveAmountDue: "ئێستا پێویستە: {amount} — دەگۆڕدرێت",
    moveFillFull: "بڕی تەواو",
    moveRemainCash: "دوای وەرگرتن {amount} لای شۆفێر دەمێنێتەوە.",
    moveRemainDue: "ماوەی شایستە دوای دان: {amount}",
    moveTopupPreview: "{amount} زیاد دەکرێت بۆ جزدانی شۆفێر (پێشەکی).",
    movePreviewHint: "بڕێک بنووسە بۆ پیشاندانی کاریگەری.",
    giveReasonLabel: "پارەکە بۆ چیشە؟",
    givePayout: "دانانی شایستە",
    givePayoutHint: "شایستەی ماوە بدە بە شۆفێر (ئێستا {amount}).",
    giveTopup: "زیادکردنی باڵانس (پێشەکی)",
    giveTopupHint: "باڵانس زیاد دەکات بۆ ئەوەی لای شۆفێرە — بۆ پێشەکی.",
    moveSubmitTake: "تۆمارکردنی وەرگرتن",
    moveSubmitGive: "تۆمارکردنی دان",
    toastReceived: "{amount} لە شۆفێر وەرگیرا.",
    toastPaid: "{amount} درا بە شۆفێر.",
    toastCredited: "{amount} باڵانس زیادکرا بۆ جزدانی شۆفێر.",
    duesWarning:
      "قەرزی جزدانی کڕیار چارەسەر نەکراوە — پێش گواستنەوەی ئەم کڕیارە بۆ ژێر هاوبەش، باڵانسەکە چارەسەر بکە.",
    consolidatedNote: "فاکتۆرکردن بە جزدانی هاوبەشی کۆکراوەت دەڕوات.",
    breakdownTitle: "شیکاری حساب",
    bdTrips: "کۆی گەشتەکان",
    bdIncome: "داهاتی شۆفێر",
    bdOweDelivery: "شۆفێر بەرماڵە بە هاوبەش (گەیاندن)",
    bdOweOrder: "شۆفێر بەرماڵە بە هاوبەش (نرخی داواکاری)",
    bdPartnerOwes: "هاوبەش بەرماڵە بە شۆفێر",
    bdNote: "داهات بۆ شۆفێری گرێبەست دەمێنێت؛ خانەکان ئەوە پیشان دەدەن کە دوای ڕادەستکردنە ئاراستەکراوەکان (گەیاندن/نرخی داواکاری) ماوە. ڕادەستکردنی کاش و پارەدان باڵانسی ساف ڕێک دەخەن.",
    scopeLabel: "بەرامبەر بە",
    scopeNet: "ساف (هەموو)",
    scopeDelivery: "جیاوازی گەیاندن",
    scopeOrder: "نرخی داواکاری",
    scopeHint: "ئیختیاری: بڕەکە بۆ جیاوازی گەیاندن یان نرخی داواکارییەکان دابنێ لە جیاتی باڵانسی تەواو.",
  },
  fees: {
    type: "جۆری کرێ",
    amount: "بڕی کرێ",
    settlement: "تەسفیە",
    cashTarget: "تەسفیەی نەقد",
    perOrder: "بۆ هەر داواکاری",
    percentage: "ڕێژە",
    instant: "خێرا بۆ جزدان",
    credit: "قەرز (دواتر وەردەگیرێت)",
    targetBusiness: "تەسفیە لەگەڵ بزنس",
    targetPartner: "تەسفیە لەگەڵ هاوبەش",
    unknown: "ڕێک نەخراوە",
  },
  ledger: {
    status: {
      pending: "هەڵواسراو",
      settled: "تەسفیەکراو",
      instant: "خێرا",
      voided: "هەڵوەشێنراو",
      other: "—",
    },
  },
  payment: {
    prepaid: "پێشوەختە دراوە",
    cod: "کاتی گەیاندن",
    cashier: "لە کاشێر",
    unknown: "نەزانراو",
  },
  responsibility: {
    customer: "کڕیار",
    client: "کڕیار (بزنس)",
    free: "گەیاندنی بەخۆڕایی",
    oelox: "OELOX",
    other: "هیتر",
  },
  clientDrivers: {
    title: "چالاکی شۆفێرەکان",
    sourceNote: "لە گەیاندنەکانی فلیتی تۆ بۆ ئەم کڕیارە — تەنها لە مێژووی داواکارییەکان.",
    colDriver: "شۆفێر",
    colVehicle: "ئۆتۆمبێل",
    colTrips: "گەشتەکان",
    colKm: "کم",
    colCost: "تێچووی شۆفێر",
    colLastTrip: "دوایین گەشت",
    empty: "هیچ گەشتی شۆفێر نییە لەم ماوەیەدا.",
  },
  analytics: {
    eyebrow: "تێڕوانین",
    title: "شیکارییەکان",
    subtitle: "داواکاری، داهاتی گەیاندن، کرێی خزمەتگوزاری و کۆکردنەوە بۆ ماوەی هەڵبژێردراو.",
    allClients: "هەموو کڕیارەکان",
    all: "هەموو",
    clientFilter: "پاڵاوتن بەپێی کڕیار",
    fulfillmentFilter: "پاڵاوتن بەپێی جۆر",
    loadError: "نەتوانرا شیکارییەکان بار بکرێت. نوێکردنەوە بکە و دووبارە هەوڵ بدە.",
    kpiOrders: "داواکارییەکان",
    kpiDeliveryIncome: "داهاتی گەیاندن",
    fromCustomers: "کڕیارەکان",
    fromClients: "بزنسەکان",
    kpiClientCharges: "کرێی خزمەتگوزاری",
    kpiCod: "کاتی گەیاندن",
    kpiOutstanding: "ماوە",
    pendingAdded: "زیادکرا لە ماوە: {amount}",
    kpiWallet: "باڵانسی جزدان",
    kpiAvgFee: "ناوەندی کرێی گەیاندن",
    avgKm: "ناوەندی کم",
    avgPrep: "ناوەندی ئامادەکاری (خولەک)",
    cancelledWithFee: "{count} هەڵوەشێنراو لەگەڵ کرێ",
    ordersPerDay: "داواکاری ڕۆژانە",
    incomePerDay: "داهاتی گەیاندن ڕۆژانە",
    byClient: "بەپێی کڕیار",
    byDriver: "بەپێی شۆفێر",
    empty: "هیچ داتایەک نییە لەم ماوەیەدا.",
    colClient: "کڕیار",
    colOrders: "داواکاری",
    colCompleted: "تەواوکراو",
    colCancelled: "هەڵوەشێنراو",
    colDeliveryFees: "کرێی گەیاندن",
    colCharges: "کرێی خزمەتگوزاری",
    colOutstanding: "ماوە",
    colDriver: "شۆفێر",
    colTrips: "گەشتەکان",
    colKm: "کم",
    colLastTrip: "دوایین گەشت",
    colDriverCost: "تێچووی شۆفێر",
    profitabilityTitle: "قازانج (ئەم ماوەیە)",
    profitRevenue: "داهات (خەمڵاندن)",
    profitDriverCosts: "تێچووی شۆفێرەکان",
    profitOelox: "کرێی گەشتی OELOX",
    profitEstimated: "قازانجی خەمڵێنراو",
    profitMarginValue: "لێواری {pct}%",
    profitSettledTrips: "{count} گەشتی تەسفیەکراو",
    profitVoided: "هەڵوەشێنراو: {amount}",
    profitNoRates:
      "کرێی شۆفێر بۆ هەر گەشت لە ڕێکخستن ← ناردن (یان بۆ هەر شۆفێر) دیاری بکە بۆ هەژمارکردنی تێچوو.",
    pendingNote:
      "تێچووی شۆفێر لە کرێی پاشەکەوتکراوی هەر گەشت وەردەگیرێت؛ کرێی OELOX لە تەسفیەی گەشتەکان.",
  },
  settings: {
    eyebrow: "فەزای کار",
    title: "ڕێکخستنەکان",
    subtitle: "پرۆفایلی هاوبەش، دۆخی ناردن، هەڵبژاردەکان و زانیاری سیستەم.",
    segmentsAria: "بەشەکانی ڕێکخستن",
    loadError: "نەتوانرا ڕێکخستنی هاوبەش بار بکرێت. نوێ بکەرەوە و دووبارە هەوڵ بدە.",
    languageCardTitle: "زمان",
    languageCardText: "عەرەبی یان کوردی یان ئینگلیزی بۆ فەزای کاری هاوبەش.",
    tabs: {
      profile: "پرۆفایل",
      dispatch: "ناردن",
      fees: "کرێی گەیاندن",
      preferences: "هەڵبژاردەکان",
      system: "سیستەم",
    },
    fees: {
      title: "کرێی گەیاندن",
      hint: "باندەکانی دووری بۆ گەیاندنی کڕیارە پەیوەندیدارەکان. ئەپ و ژیریی دەستکرد هەمان ئەم نرخانە دەخوێننەوە.",
      add: "زیادکردنی باند",
      save: "پاشەکەوتکردنی کرێ",
      saved: "کرێی گەیاندن پاشەکەوتکرا",
      saveFailed: "نەتوانرا کرێی گەیاندن پاشەکەوت بکرێت.",
      empty: "هێشتا باند نییە — یەکەم دانە زیاد بکە.",
      minKm: "کەمترین کم",
      maxKm: "زۆرترین کم",
      fee: "کرێ",
      driverAmount: "کرێی شۆفێر",
      margin: "قازانج",
      remove: "سڕینەوەی باند",
      calculator: "ژمێرەری کرێ",
      calculatorHint: "دووری بجوڵێنە بۆ بینینی کرێ.",
      testDistance: "دووری تاقیکاری: {distance}",
      noBand: "هیچ باندێک ئەم دوورییە ناگرێتەوە.",
      result: "کرێ: {fee}",
      errors: {
        invalid: "ژمارەی دروست بنووسە.",
        range: "زۆرترین دەبێت لە کەمترین گەورەتر بێت.",
        fee: "کرێ دەبێت لە 0 گەورەتر بێت.",
        driver: "کرێی شۆفێر دەبێت ژمارەیەکی دروست بێت.",
        driverOverFee: "کرێی شۆفێر نابێت لە کرێی کڕیار زیاتر بێت.",
        overlap: "باندەکان بەسەر یەکتردا دەچن — دوورییەکان ڕێک بخە.",
      },
    },
    profile: {
      title: "پرۆفایلی هاوبەش",
      hint: "ناسنامەی بزنس بۆ ئەم هاوبەشە. ناو و پەیوەندی لە ناوەندەوە بەڕێوە دەبرێن.",
      logo: "لۆگۆ",
      logoHint: "تەنها خانەی براند لە ڕێگەی RPCـی پرۆفایل دەگۆڕدرێت.",
      changeLogo: "گۆڕینی لۆگۆ",
      uploading: "بارکردن…",
      businessInfo: "زانیاری بزنس",
      businessHint: "تەنها خوێندنەوە لە پرۆفایلی هاوبەش.",
      name: "ناوی هاوبەش",
      slug: "ناسنامە",
      status: "دۆخ",
      contactEmail: "ئیمەیڵی پەیوەندی",
      displayName: "ناوی پیشاندان",
      role: "ڕۆڵەکەت",
      toastSaved: "لۆگۆ نوێ کرایەوە.",
    },
    dispatch: {
      title: "ڕێکخستنی ناردن",
      hint: "تەنها ئاڵای ڕێکخستن — لۆژیکی دیاریکردن لەم UIـەدا ناگۆڕێت.",
      modeTitle: "دۆخی ناردن",
      modeHint: "دیاریکردنی دەستی یان بڵاوکردنەوەی خۆکاری فلیتی هاوبەش.",
      modeAria: "دۆخی ناردن",
      manualTitle: "ناردنی دەستی",
      manualHint: "خۆت قبوڵ بکە و شۆفێری هاوبەش دیاری بکە.",
      bypassTitle: "تێپەڕین (بڵاوکردنەوەی خۆکار)",
      bypassHint: "قبوڵ و بڵاوکردنەوەی خۆکار بۆ شۆفێرە چالاکەکانی هاوبەش.",
      fallbackTitle: "یەدەگی OELOX",
      fallbackHint: "ڕێگەبدە بە داواکردنی شۆفێری OELOX کاتێک فلیت ناتوانێت.",
      fallbackToggle: "یەدەگی خۆکار (OELOX)",
      fallbackDesc: "تەنها ئاڵای ڕێکخستن. کردارەکانی داواکاری هێشتا یاسای سێرڤەر جێبەجێ دەکەن.",
      driverModeTitle: "دۆخی بنەڕەتی شۆفێر",
      driverModeHint: "بۆ شۆفێرە نوێیەکان و ئەوانەی دۆخی تایبەتیان نییە بەکاردێت.",
      driverModeOwnHint: "هاوبەش هەموو کرێی گەیاندن دەهێڵێتەوە.",
      driverModePaidHint: "کرێی شۆفێر لە جزدانی شۆفێردا دەشوێنرێت.",
      payTitle: "کرێی شۆفێر بۆ هەر گەشت",
      payHint:
        "بڕی بنەڕەتی پارەدان بە شۆفێر بۆ هەر گەشتی گەیاندنی تەواوکراو (IQD). بۆ هەر شۆفێر دەگۆڕدرێت.",
      payLabel: "کرێی بنەڕەتی بۆ هەر گەشت (IQD)",
      payPlaceholder: "بۆ نموونە 2000",
      paySave: "پاشەکەوتکردنی کرێ",
      paySaved: "کرێی بنەڕەتی شۆفێر نوێکرایەوە.",
      payDriverHint:
        "بەکاردێت کاتێک شۆفێر کرێی تایبەتی نییە. کرێ لەسەر هەر گەشت دەچەسپێت کاتێک تەواو دەبێت.",
      toastSaved: "ڕێکخستنی ناردن پاشەکەوت کرا.",
    },
    preferences: {
      title: "هەڵبژاردەکانی کارپێکردن",
      hint: "تەنها هەڵبژاردەی UI لەم وێبگەڕەدا. نووسینی سێرڤەر نییە.",
      stageTitle: "سەرنجدان لە قۆناغی داواکاریی بنەڕەتی",
      stageHint: "تەنها هەڵبژاردەی پیشاندان — ڕێڕەوی داواکاری ناگۆڕێت.",
      stageAll: "هەموو قۆناغەکان",
      stagePending: "چاوەڕوان",
      stageProcessing: "لە پرۆسەدا",
      stageReady: "ئامادە",
      notifyTitle: "ئاگادارییەکان",
      notifyHint: "کلیدی ناوخۆیی بۆ ئاگاداری داهاتوو — هێشتا بە پەش بەستراو نییە.",
      notifyOrders: "داواکاری نوێ",
      notifyOrdersDesc: "دیاریکردن کاتێک داواکاری هاوبەشی نوێ دێت.",
      notifyDrivers: "نوێکردنەوەی شۆفێر",
      notifyDriversDesc: "دۆخی ئۆنلاین / دیاریکردنی شۆفێر.",
      notifyFallback: "ئاگاداری یەدەگی OELOX",
      notifyFallbackDesc: "کاتێک یەدەگ بەکاردێت یان بەردەست نییە.",
      toastSaved: "هەڵبژاردەکان لەم ئامێرەدا پاشەکەوت کران.",
    },
    system: {
      title: "زانیاری سیستەم",
      hint: "وێنەیەکی کارپێکردنی تەنها-خوێندنەوە بۆ ئەم هاوبەشە.",
      partnerId: "ناسنامەی هاوبەش",
      partnerStatus: "دۆخی هاوبەش",
      activeClients: "کڕیارە چالاکەکان",
      clientsValue: "{active} چالاک / {total} کۆ",
      activeDrivers: "شۆفێرە چالاکەکان",
      driversValue: "{fleet} فلیت / {online} ئۆنلاین",
      dispatchMode: "دۆخی ناردن",
      bypassLabel: "تێپەڕین (بڵاوکردنەوەی خۆکار)",
      manualLabel: "دەستی",
      fallback: "یەدەگی OELOX",
      driverMode: "دۆخی بنەڕەتی شۆفێر",
      oeloxTripFee: "کرێی OELOX بۆ هەر گەشت",
      oeloxBalance: "باڵانسی جزدانی OELOX",
      oeloxLimit: "سنووری نەرێنی OELOX",
      oeloxWalletNote:
        "OELOX کرێی هەر گەشت لەم جزدانە کەم دەکاتەوە؛ پڕکردنەوە لە ڕێی پشتگیری OELOX دەبێت.",
    },
  },
  accounts: {
    eyebrow: "زانیاری چوونەژوورەوە",
    username: "ناوی بەکارهێنەر",
    password: "وشەی نهێنی",
    initialPassword: "وشەی نهێنی سەرەتایی",
    newPassword: "وشەی نهێنی نوێ",
    passwordPlaceholder: "لە کەمترین ٨ پیت",
    passwordMin: "لە کەمترین ٨ پیت بەکاربهێنە.",
    generate: "دروستکردن",
    show: "پیشاندانی وشەی نهێنی",
    hide: "شاردنەوەی وشەی نهێنی",
    shownOnce:
      "وشەی نهێنی تەنها ئێستا پیشان دەدرێت. بە شێوەی هاشێکی پارێزراو هەڵدەگیرێت و چیتر پیشان نادرێت — ئەگەر ون بوو «دووبارە دانانی وشەی نهێنی» بەکاربهێنە.",
    done: "تەواو، پاشەکەوتم کرد",
    checking: "پشکنین…",
    available: "بەردەستە",
    resetTitle: "دووبارە دانانی وشەی نهێنی",
    resetHint:
      "وشەیەکی نهێنی نوێ بۆ ئەم هەژمارە هەڵبژێرە. وشەی نهێنی ئێستا ناگەڕێتەوە؛ نوێیەکە یەکجار پیشان دەدرێت.",
    resetCta: "دانانی وشەی نهێنی",
    resetAction: "دووبارە دانانی وشەی نهێنی",
    usernameLocked:
      "داخراوە — ناوی بەکارهێنەری چوونەژوورەوە دوای چالاککردن ناگۆڕدرێت.",
  },
  errors: {
    walletDuesUnsettled: "قەرزی جزدانی کڕیار چارەسەر نەکراوە — سەرەتا چارەسەری بکە.",
    walletCashExceeds: "بڕەکە زیاترە لەو پارەیەی لای شۆفێرە.",
    walletPayoutExceeds: "بڕەکە زیاترە لە شایستەی دان.",
    walletScopeExceeds: "بڕەکە لەوەی ماوە لەم خانەیە زیاترە.",
    walletScopeInvalid: "ئاراستەی ڕادەستکردن نادروستە.",
    walletKindInvalid: "جۆری تسویە نادروستە.",
    partnerClientNotFound: "ئەم کڕیارە بەستنی بە هەژمارەکەت نییە.",
    requestFailed: "داواکاری سەرنەکەوت.",
    usernameTaken: "ناوی بەکارهێنەر پێشتر بەکارهاتووە. یەکێکی تر تاقی بکەوە.",
    usernameInvalid:
      "ناوی بەکارهێنەر نادروستە. ٣–٣٠ پیت بەکاربهێنە: a-z، 0-9، تەنها داش.",
    clientNotFound: "کڕیار بۆ ئەم هاوبەشە نەدۆزرایەوە.",
    forbidden: "دەستپێگەیشتنت بۆ ئەم کردارە نییە.",
    somethingWrong: "هەڵەیەک ڕوویدا.",
    roleCannotChange: "ڕۆڵەکەت ناتوانێت ئەم ڕێکخستنانە بگۆڕێت.",
    partnerAccessDenied: "دەستگەیشتنی هاوبەش ڕەتکرایەوە.",
    invalidDispatchMode: "دۆخی ناردنی نادروست.",
    fallbackDisabled: "یەدەگی OELOX بۆ ئەم هاوبەشە ناچالاکە.",
    driversAvailable: "شۆفێری هاوبەش بەردەستن — لە فلیتەکەت دیاری بکە.",
    noOeloxDrivers: "ئێستا هیچ شۆفێری OELOX بەردەست نییە.",
    acceptFirst: "پێش دیاریکردنی شۆفێر داواکاری قبوڵ بکە.",
    walletBelowLimit:
      "باڵانسی جزدان لە سنووری کرێدیت خوارترە — ناردن ڕاگیراوە. داوای پڕکردنەوەی جزدان لە OELOX بکە.",
    noDispatchAuthority: "دەسەڵاتی ناردن بۆ ئەم بزنسە نییە.",
    alreadyAssigned: "داواکاری پێشتر بۆ شۆفێرێکی تر دیاری کراوە.",
    driverFull:
      "شۆفێر گەیشتە سنووری زۆرترین — دوو داواکاری بە یەکجار (داواکاری هەمان فرۆشگا بێ سنوورە).",
    groupRound:
      "ئەم داواکارییە بەشێکە لە یەک گەڕ — هەموو گەڕەکە لە کارتی گروپەوە قبوڵ یان ڕەت یان بنێرە (ئەپی مۆبایل).",
    alreadyAccepted: "داواکاری پێشتر قبوڵ کراوە.",
    orderClosed: "داواکاری پێشتر داخراوە.",
    driverNotInFleet: "ئەم شۆفێرە لە فلیتی هاوبەشدا نییە.",
    nameRequired: "ناوی شۆفێر پێویستە.",
    phoneInvalid: "ژمارەی تەلەفۆنی دروست بنووسە.",
    phoneTaken: "ئەم ژمارەی تەلەفۆنە پێشتر بەکارهاتووە.",
    driverOtherPartner: "ئەم شۆفێرە پێشتر هی هاوبەشێکی ترە.",
    driverInactive: "ئەم شۆفێرە چالاک نییە.",
    driverActiveOrders: "شۆفێر گەیاندنی چالاکی هەیە — سەرەتا تەواوی بکە یان دووبارە دیاری بکە.",
    vehicleInvalid: "جۆری ئۆتۆمبێلی نادروست.",
    driverNotFound: "شۆفێر لە فلیتەکەتدا نەدۆزرایەوە.",
    driverModeInvalid: "دۆخی شۆفێری نادروست.",
    amountInvalid: "بڕێکی ناسفر بنووسە.",
    amountTooLarge: "بڕەکە زۆر گەورەیە.",
    invalidTripFee: "بڕێکی دروست بنووسە (0 یان زیاتر).",
    slugTaken: "ئەم لینکی گشتی پێشتر بۆ فرۆشگایەکی تر بەکارهاتووە.",
    slugInvalid:
      "لینکی نادروست. ٣–٦٠ پیتی لاتینی بچووک، ژمارە یان داشی تاک بەکاربهێنە.",
    passwordTooWeak: "وشەیەکی نهێنی لە کەمترین ٨ پیت بەکاربهێنە.",
    emailInvalid: "ئیمەیڵێکی دروست بنووسە.",
    credentialsUnavailable: "ئەم هەژمارە هێشتا زانیاری چوونەژوورەوەی نییە — سەرەتا چالاکی بکە.",
    requiredFields: "هەموو خانە پێویستەکان پڕ بکەرەوە.",
    notFound: "هەژمارەکە بۆ ئەم هاوبەش نەدۆزرایەوە.",
    rateLimited: "هەوڵی زۆر. دواتر هەوڵ بدە.",
  },
};

export default ku;
